import { RequestService } from '../services';
export const mediaActions = {
    UploadFile
}
function UploadFile(file, collection) {
    return RequestService.PostRequest(`media/upload/${collection}`, file, true)
}